// Libraries
import getSymbolFromCurrency from "currency-symbol-map";
// Api
import {
  GetBusinessUnit_businessUnit,
  GetBusinessUnit_businessUnit_regulatorySystem,
} from "api/BusinessUnits/types/GetBusinessUnit";
// Utils
import { getBUFromLocalStorage } from "helpers/storage";
import { getCurrencyCode, getWeightUnitName } from "helpers/general";
import { useStateSpecies } from "hooks";
import { useGetBusinessUnitQuery } from "generated/graphql";

export enum CountriesCodes {
  GB = "gb",
  US = "us",
  AU = "au",
}

export const useGetCurrentBusinessUnit = () => {
  const { active: speciesActive } = useStateSpecies();
  const businessUnit = getBUFromLocalStorage();
  const { data } = useGetBusinessUnitQuery({
    variables: {
      businessUnit,
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });

  const currentBU = (data?.businessUnit || {}) as GetBusinessUnit_businessUnit;
  const weightUnits: string = getWeightUnitName(currentBU?.unitsOfMeasurement || []);
  const currencyCodeISO: string = getCurrencyCode(currentBU?.currency?.code);
  const currencySymbol: string = getSymbolFromCurrency(currencyCodeISO) || "£";
  const countryCode: string = data?.businessUnit?.country?.code?.toLowerCase() || CountriesCodes.GB;
  const countryIsoCode = data?.businessUnit?.country?.isoAlpha2?.toLowerCase() || "gb";
  const animalType = speciesActive || currentBU?.farmAnimalTypes?.find((item) => item.slug === "cattle") || null;
  const regulator = data?.businessUnit?.regulatorySystem as GetBusinessUnit_businessUnit_regulatorySystem | null;

  return {
    ...currentBU,
    weightUnits,
    regulator,
    currencyCodeISO,
    currencySymbol,
    countryCode,
    animalType,
    countryIsoCode,
  };
};
